/**
 * On-match view helpers (NLU P1 plan C1). Import-free so `node --test` loads it directly; the server validates the
 * same shapes (backend intent/on-match.ts).
 */
export type V2Channel = 'FACEBOOK' | 'INSTAGRAM' | 'TELEGRAM' | 'VIBER' | 'CUSTOM_CHANNEL';
export const PICKER_CHANNELS: V2Channel[] = ['FACEBOOK', 'INSTAGRAM'];

export type BlockRef = { id: number; name: string; checkedAt: string };
export type OnMatch =
  | { type: 'none' }
  | { type: 'reply'; text: string }
  | { type: 'block'; blocks: Partial<Record<V2Channel, BlockRef>> };

export function actionLabel(o: OnMatch | null | undefined): string {
  if (!o) return '—';
  if (o.type === 'none') return 'Nothing';
  if (o.type === 'reply') return 'Reply';
  return `Block (${Object.keys(o.blocks).join(', ')})`;
}

export function isComplete(o: OnMatch): boolean {
  if (o.type === 'reply') return o.text.trim().length > 0 && o.text.length <= 2000;
  if (o.type === 'block') return Object.keys(o.blocks).length > 0;
  return true;
}

export function missingFor(intentId: string, stale: Record<string, string[]>): string[] {
  return stale[intentId] ?? [];
}
